import React from "react";
import { TemporaryPassenger } from "types";

import ATICreateWrapper from "./components/ATICreateWrapper";
import ATIUpdateWrapper from "./components/ATIUpdateWrapper";

type AdditionalTripInfoDialogProps = {
  mode: "create" | "update";
  onClose: () => void;
  open: boolean;
  trip: {
    id: string;
    totalGroupSize: number;
    note?: string;
    temporaryPassenger?: TemporaryPassenger;
    routes: {
      id: string;
      carryOnLuggage?: number;
      checkedLuggage?: number;
      oversizeLuggage?: number;
    }[];
  };
  isRoundTrip?: boolean;
};

function AdditionalTripInfoDialog(props: AdditionalTripInfoDialogProps) {
  const { mode, onClose, open, trip, isRoundTrip } = props;

  if (mode === "create") {
    return <ATICreateWrapper onClose={onClose} open={open} trip={trip} />;
  }

  return (
    <ATIUpdateWrapper
      onClose={onClose}
      open={open}
      trip={trip}
      isRoundTrip={isRoundTrip}
    />
  );
}

export default AdditionalTripInfoDialog;
